module.exports = __webpack_public_path__ + "static/media/catalogueImg2.14f8ed73.png";